import PropTypes from 'prop-types';

import DateAnswer from './components/DateAnswer';
import MultipleChoiceAnswer from './components/MultipleChoiceAnswer';
import NumberAnswer from './components/NumberAnswer';
import TextAnswer from './components/TextAnswer';
import UploadAnswer from './components/UploadAnswer';

const components = {
  date: DateAnswer,
  decimal: NumberAnswer,
  integer: NumberAnswer,
  'multiple-answer': MultipleChoiceAnswer,
  'multiple-choice': MultipleChoiceAnswer,
  text: TextAnswer,
  upload: UploadAnswer,
  'yes-no': MultipleChoiceAnswer,
};

export function getAnswerComponent(type) {
  return components[type] || 'div';
}

export const questionTypes = Object.keys(components);

export const questionPropType = PropTypes.shape({
  is_required: PropTypes.bool,
  number: PropTypes.number,
  question_as_html: PropTypes.string,
  question_id: PropTypes.number.isRequired,
  question_type: PropTypes.oneOf(questionTypes),
  uploadParameters: PropTypes.shape({
    extensions: PropTypes.arrayOf(PropTypes.string),
    max_bytes: PropTypes.number,
    max_bytes_string: PropTypes.string,
    types: PropTypes.arrayOf(PropTypes.string),
  }),
});

export default questionTypes;
